import React from 'react';

export const Spinner = () => {
	return (
		<div class="lds-roller">
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
			<div />
		</div>
	);
};
